import { Drawer, Modal, Stack } from "@mantine/core";
import React                    from "react";

import { useGetDeviceType } from "_common/hooks/global";
import PrimaryButton        from "_components/atoms/button/primaryButton";
import SecondaryButton      from "_components/atoms/button/secondaryButton";
import Icon                 from "_components/atoms/icon";
import Typography           from "_components/atoms/typography";

import useStyles from "./styles";

const InnerComponent = props => {
	const {
		title, subtitle, content, primaryCtaText,
		secondaryCtaText, onClickPrimaryCta,
		onClickSecondaryCta, close, withCloseButton,
		opened, setOpened, icon
	} = props;
	const { classes } = useStyles ();

	return (
		<>
			<Stack
				align = "center"
				p     = "md"
				style = { { gap: "0" } }
			>

				{withCloseButton === false ? null : (
					<Icon
						className = { classes.closeIcon }
						name      = "cross"
						onClick   = { () => setOpened ( false ) }
						size      = { 36 }
					/>
				)}

				{icon ? (
					<Icon
						sameInBothTheme
						name = { icon }
						size = { 60 }
					/>
				) : null}

				<Typography
					mt     = "lg"
					size   = "lg"
					ta     = "center"
					title  = { title }
					weight = "500"
				/>

				<Typography
					dimmed
					ta    = "center"
					title = { subtitle }
				/>
			</Stack>

			{content}

			<Stack
				fullWidth
				align   = "stretch"
				my      = "md"
				spacing = { "md" }
				w       = "100%"
			>

				{primaryCtaText && (
					<PrimaryButton
						fullWidth
						className = { classes.btn }
						onClick   = { onClickPrimaryCta || close }
						title     = { primaryCtaText }
					/>
				)}

				{secondaryCtaText && (
					<SecondaryButton
						fullWidth
						className = { classes.btn }
						onClick   = { onClickSecondaryCta || close }
						size      = "sm"
						title     = { secondaryCtaText }
					/>
				)}

			</Stack>
		</>
	);
};

const Component = props => {

	const {
		opened, setOpened
	} = props;

	const { classes, cx } = useStyles ( undefined, { name: "confirmationModal" } );
	const deviceType      = useGetDeviceType ();
	const isMobile        = deviceType === "mobile";

	if ( isMobile )
		return (
			<Drawer
				// centered
				classNames          = { {
					content : classes.drawerContent,
					body    : classes.drawerBody
				} }
				closeOnClickOutside = { false }
				closeOnEscape       = { false }
				onClose             = { () => {
					setOpened ( false );
				} }
				opened              = { opened }
				position            = "bottom"
				transitionProps     = { { transition: "slide-up", duration: 100 } }
				withCloseButton     = { false }
				zIndex              = { 1300 }
			>
				<InnerComponent { ...props } />
			</Drawer>
		);

	return (
		<Modal
			centered
			classNames          = { {
				content : classes.modalContent,
				body    : classes.modalBody
			} }
			closeOnClickOutside = { false }
			closeOnEscape       = { false }
			onClose             = { () => {
				setOpened ( false );
			} }
			opened              = { opened }
			radius              = { "xl" }
			transitionProps     = { { transition: "slide-up", duration: 100 } }
			withCloseButton     = { false }
			zIndex              = { 1300 }
		>
			<InnerComponent
				{ ...props }
			/>
		</Modal>
	);
};

export default Component;
